import {Badge} from "@mui/material";
import Icon from "./Icon";

export default function Filter({count, type, toggle, onClick}){

    return <Badge 
        badgeContent={count} 
        color={toggle ? 'primary' : 'action'} 
        onClick={onClick}
        sx={{cursor: 'pointer'}}
    >
        <Icon type={type} color={'action'} />
    </Badge>
}